<app-modal-header [title]="'Termo de Compromisso'"></app-modal-header>

<mat-dialog-content class="content-dialog" #termContent (scroll)="scrollHandler($event)">
  @if (loading) {
    <app-loading></app-loading>
  }
  @if (!loading) {
    <p id="term-content" innerHtml="{{term?.value}}"></p>
  }
</mat-dialog-content>

<div class="modal-footer">
  <i class="primary-text">Atualizado em: {{term?.updated_at | date: 'dd/MM/yyyy hh:mm'}}</i>
  <button id="acceptBtn" type="button" mat-raised-button color="accent" [disabled]="blockBtn" (click)="acceptTerm();">
    Aceito
  </button>
</div>
